module.exports = __webpack_public_path__ + "static/media/whiteRightArrow.a893c170.svg";